<!-- User Info & ID Match Status -->
<div class="row p-4 align-items-center pb-0">
  <div class="col-md-8 mb-2">
    <h4 class="fw-bold mb-1">{{ name || 'N/A' }}</h4>
    <span class="text-xs">
      <i class="bi bi-telephone me-1"></i>
        {{ phone_number || 'N/A' }}
    </span>
    <span class="text-xs ms-3">
      <i class="bi bi-envelope me-1"></i>
      {{ email || 'N/A' }}
    </span>
  </div>
  <div class="col-md-4 text-end">
    <!-- ID Number Match Indicator -->
    <div class="d-inline-block">
      <span class="badge verif-status-badge px-3"
        :class="checks.id_match ? 'verif-status-passed' : 'verif-status-failed'">
        <i class="bi" :class="checks.id_match ? 'bi-check-circle-fill verif-status-icon' : 'bi-x-circle-fill verif-status-icon-fail'"></i>
        <span class="fw-bold ms-1 text-black">
          ID Match
        </span>
      </span>
    </div> 
  </div>
</div>

<div class="card-body pt-0">
  <CustomTabs :tabs="tabs" v-model="current_tab" />

  <!-- Audit Trail Tab -->
  <div v-if="current_tab === 'AuditTrail'" class="tab-pane fade show active mt-3">
    <section class="py-3">
      <div v-if="audit_trails.length === 0" class="fw-bold text-xs mb-4">
        No Audit Trail for this user found.
      </div>

      <ul v-else class="timeline text-xs">
        <li v-for="audit_trail in audit_trails" :key="audit_trail.id" class="timeline-item mb-5">
          <p class="mb-2 text-xs fw-bold text-blue">{{ audit_trail.activity }}</p>
          <p class="text-muted mb-2 fw-bold">{{ formatDateTime(audit_trail.date_created) }}</p>

          <div class="d-flex align-items-center gap-2">
            <label v-if="shouldShowSuccessIcon(audit_trail)" class="bg-success text-white rounded-small px-3">
              <i class="fa fa-check me-1" aria-hidden="true"></i>
            </label>
            <label v-if="shouldShowErrorIcon(audit_trail)" class="bg-danger text-white rounded-small px-3">
              <i class="fa fa-exclamation-triangle me-1" aria-hidden="true"></i>
            </label>

            <a v-if="shouldShowConsentLink(audit_trail.activity)" @click.prevent="fetchAndShowConsentContent(audit_trail)" href="#" class="text-primary text-decoration-underline" :class="{ 'text-muted': loadingConsentContent }">
              <i class="fa fa-spinner fa-spin me-1" v-if="loadingConsentContent && selectedAuditTrail && selectedAuditTrail.id === audit_trail.id"></i>
              {{ loadingConsentContent && selectedAuditTrail && selectedAuditTrail.id === audit_trail.id ? 'Loading...' : 'View Content' }}
            </a>
          </div>
        </li>
      </ul>
    </section>
  </div>

  <!-- Consent Modal -->
  <transition name="modal">
    <div class="modal fade show d-block terms-modal" v-if="showConsentModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content terms-modal-content">
          <div class="modal-header terms-header">
            <div class="terms-title">
              <h5 class="modal-title">{{ modalContent?.consent_type || 'Consent Content' }}</h5>
              <small class="text-muted">By {{ modalContent?.auditInfo?.customer }} on {{ formatDateTime(modalContent?.auditInfo?.date) }}</small>
            </div>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body terms-body">
            <div class="terms-text" v-html="modalContent?.content"></div>
          </div>
          <div class="modal-footer terms-footer">
            <button type="button" class="btn btn-secondary btn-terms-decline" @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <div v-if="current_tab === 'Profile'">
  <!-- CIPC Section -->
  <div class="mb-3">
    <button
      class="btn border border-2 rounded-small fw-bold text-xs shadow-sm d-flex align-items-center w-100 py-3"
      @click="toggleCipcSection"
    >
      <span class="me-2 d-flex align-items-center">
        <i class="fas me-2 text-success"></i>
        CIPC Company Verification
      </span>
      <span class="ms-2">
        <span class="badge verif-status-badge fw-bold"
          :class="checks.company_verification ? 'verif-status-passed' : 'verif-status-failed'">
          <i class="bi"
            :class="checks.company_verification ? 'bi-check-circle-fill verif-status-icon' : 'bi-x-circle-fill verif-status-icon-fail'"></i>
          {{ checks.company_verification ? 'Passed' : 'Failed' }}
        </span>
      </span>
      <span class="ms-auto">
        <i :class="{'fa fa-chevron-down': openSection !== 'cipc', 'fa fa-chevron-up': openSection === 'cipc'}"></i>
      </span>
    </button>
    <div v-show="openSection === 'cipc'" class="card shadow-sm border-0 rounded-sm mt-2">
      <div class="card-body">
        <!-- Fallback UI for CIPC -->
        <div v-if="isFallbackMode">
          <div class="alert alert-info py-2 px-3 mb-3 text-xs">
            <i class="bi bi-info-circle me-2"></i>
            CIPC was verified, but the full CIPC report data is not available for this application.
            Only limited company information is shown below.
          </div>
          <div>
            <div class="info-row small"><span class="info-label">Company Name</span><span class="info-value">{{ company_information.company_name || 'N/A' }}</span></div>
            <div class="info-row small"><span class="info-label">Registration Number</span><span class="info-value">{{ company_information.company_reg_no || 'N/A' }}</span></div>
            <div class="info-row small"><span class="info-label">Address</span><span class="info-value">{{ company_information.company_address || 'N/A' }}</span></div>
          </div>
        </div>
        <!-- Normal CIPC UI -->
        <div v-else-if="cipcReport" class="cipc-verification-report">
          <!-- Summary Card -->
          <div class="card shadow-sm mb-3 border-0">
            <div class="card-body">
              <div class="d-flex align-items-center mb-2">
                <div>
                  <div class="fw-bold fs-5">{{ cipcBusinessInfo.companyName }}</div>
                  <div class="text-muted small">
                    Reg No: <span class="fw-semibold">{{ cipcBusinessInfo.registrationNo }}</span>
                    &nbsp;|&nbsp; Directors: <span class="fw-semibold">{{ cipcBusinessInfo.directorCount }}</span>
                    &nbsp;|&nbsp; Ref: <span class="fw-semibold">{{ cipcBusinessInfo.reference }}</span>
                  </div>
                </div>
              </div>
              <div class="alert alert-info py-2 px-3 mb-0">
                <i class="bi bi-info-circle me-2"></i>
                CIPC data is sourced from the Companies and Intellectual Property Commission.
              </div>
            </div>
          </div>
          <!-- Business Info Table -->
          <div class="row g-3">
            <div class="col-md-6">
              <div class="card border-0 bg-light mb-3">
                <div class="card-header bg-white border-0 pb-1">
                  <span class="fw-semibold"><i class="fas fa-briefcase me-2"></i>Business Details</span>
                </div>
                <div class="card-body pt-2 pb-1">
                  <div class="info-row"><span class="info-label">Registration Date</span><span class="info-value">{{ cipcBusinessInfo.registrationDate }}</span></div>
                  <div class="info-row"><span class="info-label">Business Start Date</span><span class="info-value">{{ cipcBusinessInfo.businessStartDate }}</span></div>
                  <div class="info-row"><span class="info-label">Financial Year End</span><span class="info-value">{{ cipcBusinessInfo.financialYearEnd }}</span></div>
                  <div class="info-row"><span class="info-label">SIC Code</span><span class="info-value">{{ cipcBusinessInfo.sic }}</span></div>
                  <div class="info-row"><span class="info-label">VAT Number</span><span class="info-value">{{ cipcBusinessInfo.vatNo }}</span></div>
                  <div class="info-row"><span class="info-label">Authorised Shares</span><span class="info-value">{{ cipcBusinessInfo.authorisedShares }}</span></div>
                  <div class="info-row"><span class="info-label">Issued Shares</span><span class="info-value">{{ cipcBusinessInfo.issuedShares }}</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card border-0 bg-light mb-3">
                <div class="card-header bg-white border-0 pb-1">
                  <span class="fw-semibold"><i class="fas fa-map-marker-alt me-2"></i>Addresses</span>
                </div>
                <div class="card-body pt-2 pb-1">
                  <div v-for="address in cipcAddresses" :key="address.AddressType + address.PostalCode" class="mb-2">
                    <div class="info-row">
                      <span class="info-label">{{ address.AddressType }}</span>
                      <span class="info-value">
                        {{ [address.Address1, address.Address2, address.Address3, address.Address4].filter(Boolean).join(', ') || address.AddressLine1 }}
                      </span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">Postal Code</span>
                      <span class="info-value">{{ address.PostalCode || 'N/A' }}</span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">Last Updated</span>
                      <span class="info-value">{{ address.LastUpdatedDate || 'N/A' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Directors Table -->
          <div class="card border-0 bg-light mb-3" v-if="cipcDirectorsList.length">
            <div class="card-header bg-white border-0 pb-1">
              <span class="fw-semibold"><i class="fas fa-users me-2"></i>Directors</span>
              <span v-if="cipcDirectorsTotalPages > 1" class="text-muted small ms-2">
                (Page {{ cipcDirectorsPage }} of {{ cipcDirectorsTotalPages }})
              </span>
            </div>
            <div class="card-body pt-2 pb-1">
              <div class="table-responsive">
                <table class="table table-sm table-hover table-compact mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Full Name</th>
                      <th class="text-xs">ID Number</th>
                      <th class="text-xs">Status</th>
                      <th class="text-xs">Appointment Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="director in cipcDirectorsPaginated" :key="director.idNo">
                      <td class="fw-semibold text-xs">{{ director.fullName }}</td>
                      <td class="text-xs">{{ director.idNo }}</td>
                      <td class="text-xs">
                        <span class="badge"
                          :class="director.status === 'Active' ? 'bg-success' : 'bg-danger'">
                          {{ director.status }}
                        </span>
                      </td>
                      <td class="text-xs">{{ director.appointmentDate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination mt-2" v-if="cipcDirectorsTotalPages > 1">
                <span
                  class="page-link"
                  :class="{ active: cipcDirectorsPage === page }"
                  v-for="page in cipcDirectorsTotalPages"
                  :key="page"
                  @click="setCipcDirectorsPage(page)"
                >{{ page }}</span>
              </div>
            </div>
          </div>

          <!-- Director Principal Cards (Historical & Principal Info) -->
          <div v-if="cipcPrincipalDirectors.length" class="row g-3">
            <h6 class="text-muted text-xs fw-semibold mb-0">
              Director Address Information
            </h6>
            <div class="col-md-6" v-for="(principal, idx) in cipcPrincipalDirectors" :key="principal.IDNo">
              <div class="card border-0 bg-light h-100">
                <div class="card-header bg-white border-0 pb-1 d-flex align-items-center justify-content-between">
                  <span class="fw-semibold">
                    <i class="fas fa-user me-2"></i>
                    {{ principal.Fullname || principal.FullName || principal.Name || principal.FirstName + ' ' + principal.Surname }}
                  </span>
                  <button
                    class="btn btn-link btn-sm text-decoration-none"
                    @click="principalDropdowns[idx] = !principalDropdowns[idx]"
                  >
                    <span class="small text-primary">
                      {{ principalDropdowns[idx] ? 'Hide Details' : 'Show Details' }}
                      <i :class="principalDropdowns[idx] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    </span>
                  </button>
                </div>
                <transition name="fade">
                  <div v-show="principalDropdowns[idx]" class="card-body pt-2 pb-1">
                    <div class="info-row"><span class="info-label">ID Number</span><span class="info-value">{{ principal.IDNo || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Status</span><span class="info-value">{{ principal.DirectorStatusCode || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Appointment Date</span><span class="info-value">{{ principal.AppointmentDate || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Resignation Date</span><span class="info-value">{{ principal.ResignationDate || principal.DirectorStatusDate || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Birth Date</span><span class="info-value">{{ principal.BirthDate || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Age</span><span class="info-value">{{ principal.Age || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Years With Business</span><span class="info-value">{{ principal.YearsWithBusiness || principal.YearsWithBus || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Physical Address</span><span class="info-value">{{ principal.PhysicalAddress || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Postal Address</span><span class="info-value">{{ principal.PostalAddress || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Cellular No</span><span class="info-value">{{ principal.CellularNo || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Work Tel</span><span class="info-value">{{ principal.WorkTelephoneNo || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Home Tel</span><span class="info-value">{{ principal.HomeTelephoneNo || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Email</span><span class="info-value">{{ principal.EmailAddress || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">Country</span><span class="info-value">{{ principal.CountryCode || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">RSA Resident</span><span class="info-value">{{ principal.ISRSAResident || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">ID Verified</span><span class="info-value">{{ principal.ISIDVerified || 'N/A' }}</span></div>
                    <div class="info-row"><span class="info-label">CIPRO Confirmed</span><span class="info-value">{{ principal.ISCIPROConfirmed || 'N/A' }}</span></div>
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <!-- Change History Table with Pagination -->
          <div v-if="cipcChangeHistory.length" class="card border-0 bg-light mb-3">
            <div class="card-header bg-white border-0 pb-1 d-flex align-items-center justify-content-between">
              <span class="fw-semibold"><i class="bi bi-clock-history me-2"></i>Change History</span>
              <div v-if="cipcChangeHistoryTotalPages > 1" class="pagination mb-0">
                <span
                  class="page-link"
                  :class="{ active: cipcChangeHistoryPage === page }"
                  v-for="page in cipcChangeHistoryTotalPages"
                  :key="page"
                  @click="setCipcChangeHistoryPage(page)"
                >{{ page }}</span>
              </div>
            </div>
            <div class="card-body pt-2 pb-1">
              <div class="table-responsive">
                <table class="table table-bordered align-middle table-sm mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Date</th>
                      <th>Type</th>
                      <th>Memo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(change, idx) in cipcChangeHistoryPaginated" :key="idx">
                      <td>{{ change.EffectiveDate || 'N/A' }}</td>
                      <td>{{ change.CommercialChangeTypeCode || 'N/A' }}</td>
                      <td>{{ change.Memo || 'N/A' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-warning">No CIPC report data available.</div>
      </div>
    </div>
  </div>
  <!-- IDV Section -->
  <div class="mb-3">
    <button
      class="btn border border-2 rounded-small fw-bold text-xs shadow-sm d-flex align-items-center w-100 py-3"
      @click="toggleIdvSection"
    >
      <span class="me-2 d-flex align-items-center">
        <i class="bi me-2 text-primary"></i>
        ID Liveness Verification
      </span>
      <!-- Verification badge -->
      <span class="ms-2">
        <span class="badge verif-status-badge fw-bold"
          :class="checks.facial_biometrics ? 'verif-status-passed' : 'verif-status-failed'">
          <i class="bi"
            :class="checks.facial_biometrics ? 'bi-check-circle-fill verif-status-icon' : 'bi-x-circle-fill verif-status-icon-fail'"></i>
          {{ checks.facial_biometrics ? 'Passed' : 'Failed' }}
        </span>
      </span>
      <span class="ms-auto">
        <i :class="{'fa fa-chevron-down': openSection !== 'idv', 'fa fa-chevron-up': openSection === 'idv'}"></i>
      </span>
    </button>
    <div v-show="openSection === 'idv'" class="card shadow-sm border-0 rounded-sm mt-2">
      <div class="card-body">
        <!-- Fallback UI for IDV -->
        <div v-if="isFallbackMode">
          <div class="alert alert-info py-2 px-3 mb-3 text-xs">
            <i class="bi bi-info-circle me-2"></i>
            IDV was verified, but the full IDV report data is not available for this application.
            Only limited personal information is shown below.
          </div>
          <div>
            <div class="info-row small"><span class="info-label">Name (as written on registration)</span><span class="info-value">{{ name || 'N/A' }}</span></div>
            <div class="info-row small"><span class="info-label">ID Number</span><span class="info-value">{{ profile_information.id_number || 'N/A' }}</span></div>
            <div class="info-row small">
              <span class="info-label">Client Admin Image</span>
              <span class="text-center">
                <img
                  v-if="customer_image"
                  :src="customer_image.startsWith('data:') ? customer_image : 'data:image/jpeg;base64,' + customer_image"
                  alt="Customer Image"
                  class="verification-image img-thumbnail"
                />
                <div v-else class="no-image small text-muted">
                  <i class="bi bi-image"></i>
                  <p>No client admin image</p>
                </div>
              </span>
            </div>
          </div>
        </div>
        <!-- Normal IDV UI -->
        <div v-else-if="idvReport" class="id-liveness-verification-report">
          <!-- Summary Card -->
          <div class="card shadow-sm mb-3 border-0">
            <div class="card-body">
              <div class="d-flex align-items-center mb-2">
                <div>
                  <div class="fw-bold fs-5">{{ idvReport.FirstName }} {{ idvReport.LastName }}</div>
                  <div class="text-muted small">
                    ID Number: <span class="fw-semibold">{{ idvReport.IdNumber }}</span>
                    &nbsp;|&nbsp; Marital Status: <span class="fw-semibold">{{ idvReport.MaritalStatus }}</span>
                  </div>
                </div>
              </div>
              <div class="alert alert-info py-2 px-3 mb-0">
                <i class="bi bi-info-circle me-2"></i>
                IDV data is sourced from the Department of Home Affairs.
              </div>
            </div>
          </div>
          <!-- Status Cards -->
          <div class="row g-2 mb-3">
            <div class="col-md-4">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-person-check"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Liveness Status</div>
                  <div class="status-value-simple bg-white"
                    :class="idvReport.LivenessResult?.LivenessPassResult ? 'text-success' : 'text-danger'">
                    {{ idvReport.LivenessResult?.LivenessPassResult ? 'Live' : 'Spoof' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-person-badge"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Facial Match</div>
                  <div class="status-value-simple bg-white"
                    :class="idvReport.FaceResult?.isIdentical ? 'text-success' : 'text-danger'">
                    {{ idvReport.FaceResult?.isIdentical ? 'Match' : 'No Match' }}
                    <span v-if="idvReport.FaceResult?.confidence">
                      ({{ (idvReport.FaceResult.confidence * 100).toFixed(1) }}%)
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-file-earmark-check"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">ID Verification</div>
                  <div class="status-value-simple bg-white"
                    :class="idvReport.Status === 'Success' ? 'text-success' : 'text-danger'">
                    {{ idvReport.Status === 'Success' ? 'Verified' : 'Failed' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Personal Info -->
          <div class="row g-3 mb-3">
            <div class="col-md-6">
              <div class="card border-0 bg-light">
                <div class="card-header bg-white border-0 pb-1">
                  <span class="fw-semibold"><i class="bi bi-person-circle me-2"></i>Personal Details</span>
                </div>
                <div class="card-body pt-2 pb-1">
                  <div class="info-row"><span class="info-label">Full Name</span><span class="info-value">{{ idvReport.FirstName }} {{ idvReport.LastName }}</span></div>
                  <div class="info-row"><span class="info-label">ID Number</span><span class="info-value">{{ idvReport.IdNumber }}</span></div>
                  <div class="info-row"><span class="info-label">Marital Status</span><span class="info-value">{{ idvReport.MaritalStatus }}</span></div>
                  <div class="info-row"><span class="info-label">Birth Place</span><span class="info-value">{{ idvReport.BirthPlaceCountry }}</span></div>
                  <div class="info-row"><span class="info-label">ID Issue Date</span><span class="info-value">{{ idvReport.IDIssueDate }}</span></div>
                  <div class="info-row"><span class="info-label">Smart Card</span><span class="info-value">{{ idvReport.SmartCardIssued ? 'Issued' : 'Not Issued' }}</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card border-0 bg-light">
                <div class="card-header bg-white border-0 pb-1">
                  <span class="fw-semibold"><i class="bi bi-image me-2"></i>Images</span>
                </div>
                <div class="card-body pt-2 pb-1">
                  <div class="row">
                    <div class="col-6">
                      <div class="image-section text-center mb-2">
                        <div class="image-title fw-semibold mb-1">Facial Image</div>
                        <img
                          v-if="idvReport.FacialImage"
                          :src="idvReport.FacialImage.startsWith('data:') ? idvReport.FacialImage : 'data:image/jpeg;base64,' + idvReport.FacialImage"
                          alt="Facial Image"
                          class="verification-image img-thumbnail"
                        />
                        <div v-else class="no-image small text-muted">
                          <i class="bi bi-image"></i>
                          <p>No facial image</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="image-section text-center mb-2">
                        <div class="image-title fw-semibold mb-1">Client Admin Image</div>
                        <img
                          v-if="customer_image"
                          :src="customer_image.startsWith('data:') ? customer_image : 'data:image/jpeg;base64,' + customer_image"
                          alt="Customer Image"
                          class="verification-image img-thumbnail"
                        />
                        <div v-else class="no-image small text-muted">
                          <i class="bi bi-image"></i>
                          <p>No client admin image</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Source</span>
                    <span class="info-value">Official Record / Client Admin Upload</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Available</span>
                    <span class="info-value">
                      {{ idvReport.FacialImage ? 'Facial Image: Yes' : 'Facial Image: No' }},
                      {{ customer_image ? 'Customer Image: Yes' : 'Customer Image: No' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Analysis Cards -->
          <div class="row g-3 mb-3">
            <div class="col-md-6">
              <div class="analysis-card">
                <div class="analysis-icon liveness">
                  <i class="bi bi-eye"></i>
                </div>
                <div class="analysis-content">
                  <div class="analysis-label">Liveness Detection</div>
                  <div class="analysis-value">
                    {{ idvReport.LivenessResult?.LivenessPassResult ? 'Live' : 'Spoof' }}
                  </div>
                  <div class="analysis-detail">
                    {{ idvReport.LivenessResult?.LivenessMessage || 'N/A' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="analysis-card">
                <div class="analysis-icon confidence">
                  <i class="bi bi-percent"></i>
                </div>
                <div class="analysis-content">
                  <div class="analysis-label">Face Match Confidence</div>
                  <div class="analysis-value">
                    {{ idvReport.FaceResult?.confidence ? (idvReport.FaceResult.confidence * 100).toFixed(1) : '0.0' }}%
                  </div>
                  <div class="analysis-detail">
                    Confidence: {{ idvReport.FaceResult?.confidence || 0 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="analysis-card">
                <div class="analysis-icon quality">
                  <i class="bi bi-image"></i>
                </div>
                <div class="analysis-content">
                  <div class="analysis-label">Liveness Quality</div>
                  <div class="analysis-value">
                    {{ idvReport.LivenessResult?.LivenessResultQuality ? (idvReport.LivenessResult.LivenessResultQuality * 100).toFixed(1) : '0.0' }}%
                  </div>
                  <div class="analysis-detail">
                    Score: {{ idvReport.LivenessResult?.LivenessResultQuality || 0 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="analysis-card">
                <div class="analysis-icon assessment">
                  <i class="bi bi-award"></i>
                </div>
                <div class="analysis-content">
                  <div class="analysis-label">Liveness Probability</div>
                  <div class="analysis-value">
                    {{ idvReport.LivenessResult?.LivenessResultProbability ? (idvReport.LivenessResult.LivenessResultProbability * 100).toFixed(1) : '0.0' }}%
                  </div>
                  <div class="analysis-detail">
                    Raw Score: {{ idvReport.LivenessResult?.LivenessResultScore || 0 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Verification Results Table -->
          <div class="card border-0 bg-light mb-3">
            <div class="card-header bg-white border-0 pb-1">
              <span class="fw-semibold"><i class="bi bi-check-square me-2"></i>Verification Results</span>
            </div>
            <div class="card-body pt-2 pb-1">
              <div class="table-responsive">
                <table class="table table-bordered align-middle table-sm mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Verification Check</th>
                      <th>Result</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><i class="bi bi-person-check me-2 text-secondary"></i>First Name Match</td>
                      <td>
                        <span class="badge"
                          :class="parseFloat(idvReport.FirstNameResult) >= 80 ? 'bg-success' : (parseFloat(idvReport.FirstNameResult) >= 50 ? 'bg-warning text-dark' : 'bg-danger')">
                          {{ idvReport.FirstNameResult || '0' }}%
                        </span>
                      </td>
                      <td>Percentage match between provided first name and official record.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-person-vcard me-2 text-secondary"></i>Last Name Match</td>
                      <td>
                        <span class="badge"
                          :class="parseFloat(idvReport.LastNameResult) >= 80 ? 'bg-success' : (parseFloat(idvReport.LastNameResult) >= 50 ? 'bg-warning text-dark' : 'bg-danger')">
                          {{ idvReport.LastNameResult || '0' }}%
                        </span>
                      </td>
                      <td>Percentage match between provided last name and official record.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-person-badge me-2 text-secondary"></i>Face Verification</td>
                      <td>
                        <span class="badge"
                          :class="idvReport.FaceResult?.isIdentical ? 'bg-success' : 'bg-danger'">
                          {{ idvReport.FaceResult?.isIdentical ? 'Match' : 'No Match' }}
                        </span>
                      </td>
                      <td>Facial comparison between live image and official portrait.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-eye me-2 text-secondary"></i>Liveness Check</td>
                      <td>
                        <span class="badge"
                          :class="idvReport.LivenessResult?.LivenessPassResult ? 'bg-success' : 'bg-danger'">
                          {{ idvReport.LivenessResult?.LivenessPassResult ? 'Passed' : 'Failed' }}
                        </span>
                      </td>
                      <td>Verification that the submitted image is from a live person.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-shield-check me-2 text-secondary"></i>ID Verification</td>
                      <td>
                        <span class="badge"
                          :class="idvReport.Status === 'Success' ? 'bg-success' : 'bg-danger'">
                          {{ idvReport.Status === 'Success' ? 'Verified' : 'Failed' }}
                        </span>
                      </td>
                      <td>Overall verification status combining all checks.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- Additional Info Table -->
          <div class="card border-0 bg-light">
            <div class="card-header bg-white border-0 pb-1">
              <span class="fw-semibold"><i class="bi bi-info-circle me-2"></i>Additional Information</span>
            </div>
            <div class="card-body pt-2 pb-1">
              <div class="table-responsive">
                <table class="table table-bordered align-middle table-sm mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Property</th>
                      <th>Value</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><i class="bi bi-fingerprint me-2 text-secondary"></i>Tracking Number</td>
                      <td>{{ idvReport.TrackingNumber || 'N/A' }}</td>
                      <td>Unique identifier for this verification request.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-clock me-2 text-secondary"></i>Dead Indicator</td>
                      <td>{{ idvReport.DeadIndicator ? 'Yes' : 'No' }}</td>
                      <td>Indicates if the person is recorded as deceased.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-shield-x me-2 text-secondary"></i>ID Blocked</td>
                      <td>{{ idvReport.IDBlocked ? 'Yes' : 'No' }}</td>
                      <td>Indicates if the ID is blocked or restricted.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-file-text me-2 text-secondary"></i>On HANIS</td>
                      <td>{{ idvReport.OnHanis ? 'Yes' : 'No' }}</td>
                      <td>Present on Home Affairs National Identification System.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-people me-2 text-secondary"></i>On NPR</td>
                      <td>{{ idvReport.OnNPR ? 'Yes' : 'No' }}</td>
                      <td>Present on National Population Register.</td>
                    </tr>
                    <tr>
                      <td><i class="bi bi-wallet me-2 text-secondary"></i>Wallet Created</td>
                      <td>{{ idvReport.IsWalletCreated ? 'Yes' : 'No' }}</td>
                      <td>Indicates if a digital wallet has been created.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-warning">No IDV report data available.</div>
      </div>
    </div>
  </div>
</div>
</div>
